// hooks/useCartFetcher.js
import { useCallback } from "react";
import { useDispatch } from "react-redux";
import axioswToken from "../api/axios";
import { URL } from "../url/api";
import { refreshCart } from "../reduxSetup/slices/productsSlice";

const useCart = () => {
  const dispatch = useDispatch();

  const fetchCart = useCallback(async () => {
    try {
      const response = await axioswToken.get(`${URL}/getCart`);
      const cart = response.data?.data?.cart || [];
      cart.forEach((item) => {
        dispatch(refreshCart(item));
      });
    } catch (err) {
      console.error("Error fetching cart:", err);
    }
  }, [dispatch]);

  return { fetchCart };
};

export default useCart;
